import { CountryCodeEnum } from '../../enums/shared/country-code.enum';

/**
 * European Union member states
 */
const euMemberCountries = [
  CountryCodeEnum.AT,
  CountryCodeEnum.BE,
  CountryCodeEnum.BG,
  CountryCodeEnum.HR,
  CountryCodeEnum.CY,
  CountryCodeEnum.CZ,
  CountryCodeEnum.DK,
  CountryCodeEnum.EE,
  CountryCodeEnum.FI,
  CountryCodeEnum.FR,
  CountryCodeEnum.DE,
  CountryCodeEnum.GR,
  CountryCodeEnum.HU,
  CountryCodeEnum.IE,
  CountryCodeEnum.IT,
  CountryCodeEnum.LV,
  CountryCodeEnum.LT,
  CountryCodeEnum.LU,
  CountryCodeEnum.MT,
  CountryCodeEnum.NL,
  CountryCodeEnum.PL,
  CountryCodeEnum.PT,
  CountryCodeEnum.RO,
  CountryCodeEnum.SK,
  CountryCodeEnum.SI,
  CountryCodeEnum.ES,
  CountryCodeEnum.SE,
] as CountryCodeEnum[];

/**
 * European Economic Area outside the European Union, plus Switzerland
 */
const eeaOutsideEuAndSwitzerlandCountries = [
  CountryCodeEnum.IS,
  CountryCodeEnum.LI,
  CountryCodeEnum.NO,
  CountryCodeEnum.CH,
] as CountryCodeEnum[];

/**
 * French overseas departments (DOM) and collectivities (COM) — metropolitan France is already an EU member
 */
const frenchOverseasCountries = [
  CountryCodeEnum.GP,
  CountryCodeEnum.MQ,
  CountryCodeEnum.GF,
  CountryCodeEnum.RE,
  CountryCodeEnum.YT,
  CountryCodeEnum.PM,
  CountryCodeEnum.BL,
  CountryCodeEnum.MF,
  CountryCodeEnum.WF,
  CountryCodeEnum.PF,
  CountryCodeEnum.NC,
] as CountryCodeEnum[];

/**
 * Nationalities exempt from holding a work authorization: EU, EEA outside the EU, Switzerland,
 * and France including its overseas departments and collectivities.
 */
export const workAuthorizationExemptCountries = [
  ...euMemberCountries,
  ...eeaOutsideEuAndSwitzerlandCountries,
  ...frenchOverseasCountries,
] as CountryCodeEnum[];
